<script lang="ts">
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { ResponsiveVars } from '@twist/core';

  let maxSize = 480;
  const responsiveVars = new ResponsiveVars()
    .addFluid('max-size', toFluidVarInput(maxSize, maxSize))
    .toCSS();
</script>

<div class={responsiveVars}>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 480" width="100%" height="100%">
    <g class="points">
      <polygon
        points="173.2 201.43 173.2 200.57 172.45 200.13 171.7 200.57 171.7 201.43 172.45 201.87 173.2 201.43"
      />
      <polygon
        points="240.75 162.43 240.75 161.57 240 161.13 239.25 161.57 239.25 162.43 240 162.87 240.75 162.43"
      />
      <polygon
        points="308.3 201.43 308.3 200.57 307.55 200.13 306.8 200.57 306.8 201.43 307.55 201.87 308.3 201.43"
      />
      <polygon
        points="308.3 279.43 308.3 278.57 307.55 278.13 306.8 278.57 306.8 279.43 307.55 279.87 308.3 279.43"
      />
      <polygon
        points="240.75 318.43 240.75 317.57 240 317.13 239.25 317.57 239.25 318.43 240 318.86 240.75 318.43"
      />
      <polygon
        points="173.2 279.43 173.2 278.57 172.45 278.13 171.7 278.57 171.7 279.43 172.45 279.87 173.2 279.43"
      />
      <polygon
        points="240.75 240.43 240.75 239.57 240 239.13 239.25 239.57 239.25 240.43 240 240.87 240.75 240.43"
      />
    </g>
    <g class="block">
      <path d="m240,240c34.418,12.914,50.19,34.632,67.55,39" />
      <path class="reverse" d="m240,318c8.108-28.667,24.584-51.183,67.55-39" />
      <path class="reverse" d="m240,162c-13.104,7.116-23.433,16.648-30.119,24.896" />
      <line class="reverse" x1="240" y1="162" x2="307.55" y2="201" />
      <line class="reverse" x1="172.45" y1="201" x2="240" y2="240" />
      <line class="reverse" x1="172.45" y1="279" x2="240" y2="318" />
      <line x1="172.45" y1="201" x2="172.45" y2="279" />
      <line x1="240" y1="240" x2="240" y2="318" />
      <line class="reverse" x1="307.55" y1="201" x2="307.55" y2="279" />
      <path d="m172.45,201c24.925-16.128,75.964-27.144,135.1,0" />
    </g>
  </svg>
</div>

<style lang="scss">
  div {
    height: 100%;
    max-height: var(--max-size);
  }

  line,
  path {
    stroke-width: 1.5px;
    fill: none;
    shape-rendering: auto;
  }

  .block line,
  .block path {
    stroke: #000;
    stroke-linecap: round;
    stroke-dasharray: 145;
    stroke-dashoffset: 0;
    animation-name: draw-block;
    animation-duration: 1.7s;
    stroke-dasharray: 145;
    stroke-dashoffset: -145;
    animation-iteration-count: infinite;
    animation-direction: forward;
    animation-timing-function: ease-in-out;
    &.reverse {
      animation-direction: reverse;
    }
  }

  @keyframes draw-block {
    0%,
    10% {
      stroke-dasharray: 145;
      stroke-dashoffset: -145;
    }
    40%,
    60% {
      stroke-dasharray: 145;
      stroke-dashoffset: 00;
    }
    90%,
    100% {
      stroke-dasharray: 145;
      stroke-dashoffset: 145;
    }
  }
</style>
